import { render, staticRenderFns } from "./SmallTag.vue?vue&type=template&id=06a4043a&"
import script from "./SmallTag.vue?vue&type=script&lang=js&"
export * from "./SmallTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports